import { useFormContext } from '@grnhse/seedling/lib/birch/components/forms/form';
import type { Item } from '@grnhse/seedling/lib/birch/components/forms/dropdown/item';
import React, { useCallback } from 'react';
import {
  MultiDropdown,
  useMultiDropdown,
} from '@grnhse/seedling/lib/birch/components/forms/dropdown';
import { withLocalePrefix } from 'shared/utils/translation';
import { useQueryClient } from '@tanstack/react-query';
import { useRediscoveryTabContext } from 'talent_matching/contexts/rediscovery_tab_context';

const t = withLocalePrefix('talent_matching.rediscovery.filter_row.exclusions');

const ExcludeTagsDropdown = () => {
  const queryClient = useQueryClient();
  const { apiClient } = useRediscoveryTabContext();
  const { watch, setValue } = useFormContext();
  const withoutCandidateTags: Item[] = watch('without_candidate_tags');

  const fetchTags = useCallback(
    async (term: string) => {
      const queryKey = ['candidateTags', term];

      const cachedData: Item[] | null | undefined =
        queryClient.getQueryData(queryKey);

      if (cachedData) {
        return { items: cachedData };
      }

      const items = await queryClient.fetchQuery({
        queryKey,
        queryFn: () => apiClient.fetchTags(term),
      });
      return { items };
    },
    [apiClient, queryClient]
  );

  const onSelectedTagsChange = (e: { selectedItems: Array<Item> }) => {
    setValue('without_candidate_tags', e.selectedItems, { shouldDirty: true });
  };

  const tagsDropdownProps = useMultiDropdown({
    fetchItems: fetchTags,
    onSelectedItemsChange: onSelectedTagsChange,
    selectedItems: withoutCandidateTags,
    preventLoadOnMount: true,
  });

  return (
    <MultiDropdown dropdownProps={tagsDropdownProps}>
      <MultiDropdown.Field
        data-provides="talent-rediscovery-exclude-tags-dropdown"
        label={t('exclude_tags')}
        helperText={t('exclude_tags_helper_text')}
      />
      <MultiDropdown.Flyout />
    </MultiDropdown>
  );
};

export default ExcludeTagsDropdown;
